import { render, staticRenderFns } from "./Rest.vue?vue&type=template&id=8d287d1e&scoped=true"
import script from "./Rest.vue?vue&type=script&lang=js"
export * from "./Rest.vue?vue&type=script&lang=js"
import style0 from "./Rest.vue?vue&type=style&index=0&id=8d287d1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d287d1e",
  null
  
)

export default component.exports